var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-logo"},[_c('div',{staticClass:"hidden-xs-only"},[_c('img',{attrs:{"src":_vm.logoLmhRR,"height":"50"}})]),_c('div',{staticClass:"hidden-sm-and-up"},[_c('v-layout',[_c('v-flex',[_c('img',{attrs:{"src":_vm.logoLmhRR,"height":"50"}})])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }